import { getDataFromServer } from '../../../util';

export class ClusterFeaturesModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchClusterFeaturesData = async (payload) => {
    const { clusterId } = payload;

    if (clusterId) {
      const url = `${this.baseURL}/customers/cluster/${clusterId}`;
      const data = await getDataFromServer(url, this.httpHeaders);
      if (data) {
        return data;
      }

      return {};
    } else {
      return Promise.resolve(null);
    }
  };
}
